import { mean } from 'lodash';

declare var angular: any;

angular
  .module('LessonControllers')

  .component('cfLessonsGrid', {
    bindings: {
      lessons: '<'
    },
    templateUrl: '/ng1/www/modules/lesson/html/grid.html',
    controller: [
      '$scope',
      'lesson',
      'EXAM',
      function($scope, lesson, EXAM) {
        this.helps = [
          {
            color: 'rgb(71, 189, 17)',
            text: 'mastered'
          },
          {
            color: 'rgb(229, 245, 15)',
            text: 'wip'
          },
          {
            color: 'rgb(255, 154, 2)',
            text: 'difficulties'
          },
          {
            color: 'rgb(235, 30, 7)',
            text: 'not_mastered'
          },
          {
            color: 'rgb(200, 200, 200)',
            text: 'not_worked'
          }
        ];

        let lesson_service = lesson;
        this.displayedLessons;

        this.exam = EXAM;

        this.$onChanges = () => {
          if (this.lessons) {
            this.displayedLessons = this.lessons.map(l =>
              computeLessonStyle(l)
            );
          }
        };

        let computeLessonStyle = l => {
          let scoresMean = mean(l.scores.map(score => score.value));

          let trial_count = l.scores.reduce(
            (acc, score) => acc + (score.trial_count || 0),
            0
          );

          let lessonsMean = lesson_service.getPercentage(scoresMean);
          let style;
          if (trial_count === 0) {
            style = {
              'background-color': 'rgb(200, 200, 200)'
            };
          } else if (lessonsMean > 75) {
            style = {
              'background-color': 'rgb(71, 189, 17)'
            };
          } else if (lessonsMean >= 50) {
            style = {
              'background-color': 'rgb(229, 245, 15)'
            };
          } else if (lessonsMean > 25) {
            style = {
              'background-color': 'rgb(255, 154, 2)'
            };
          } else {
            style = {
              'background-color': 'rgb(235, 30, 7)'
            };
          }

          return {
            ...l,
            style,
            mean: lessonsMean
          };
        };

        this.open = (id, ev) => {
          lesson.dialogDetail(id, ev);
        };
      }
    ]
  });
